import { render } from "./GoodItem.vue?vue&type=template&id=4cd5de8a&scoped=true"
import script from "./GoodItem.vue?vue&type=script&lang=ts"
export * from "./GoodItem.vue?vue&type=script&lang=ts"

import "./GoodItem.vue?vue&type=style&index=0&id=4cd5de8a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4cd5de8a"

export default script